"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectPartition = void 0;
const objectPartition = (obj, keys) => keys.reduce(([included, excluded], key) => {
    const { [key]: value, ...rest } = excluded;
    return typeof value !== 'undefined'
        ? [{ ...included, [key]: value }, rest]
        : [included, excluded];
}, [{}, obj]);
exports.objectPartition = objectPartition;
//# sourceMappingURL=objectPartition.js.map